import { render, staticRenderFns } from "./previewTable.vue?vue&type=template&id=e08414b6&scoped=true"
import script from "./previewTable.vue?vue&type=script&lang=js"
export * from "./previewTable.vue?vue&type=script&lang=js"
import style0 from "./previewTable.vue?vue&type=style&index=0&id=e08414b6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08414b6",
  null
  
)

export default component.exports